/* Surcharges des skins liées à l'affichage RTL */
import {IReg, REG} from "lib/commons/registry";

export function ovrReg(reg: IReg<any>) {
	/** FIXME : à supprimer qd utilisation de inset-inline-start/inset-inline-end */
	reg.overlaySkin("box-mark-rep-ctn", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  :host {
		  left: unset;
		  right: 0;
	  }
	`);

	/** FIXME : à supprimer qd utilisation de inset-inline-start/inset-inline-end */
	reg.overlaySkin("wed-diff-foreign", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  #doDiff {
		  left: unset;
		  right: -.5rem;
	  }
	`);

	/** FIXME : à supprimer qd utilisation de inset-inline-start/inset-inline-end */
	reg.overlaySkin("wed-diff-value", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  #doDiff {
		  left: unset;
		  right: -.5rem;
	  }
	`);

	/** FIXME : à supprimer qd utilisation de inset-inline-start/inset-inline-end */
	reg.overlaySkin("wed-annot-err", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  :host {
		  left: unset;
		  right: -.3rem;
	  }
	`);

	/** FIXME : à supprimer qd utilisation de inset-inline-start/inset-inline-end */
	reg.overlaySkin("wed-diff-mark", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  :host {
		  right: unset;
		  left: 0;
	  }
	`);

	/** FIXME : à supprimer qd utilisation de inset-inline-start/inset-inline-end */
	reg.overlaySkin("wed-diff-para", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  :host {
		  right: unset;
		  left: 0;
	  }
	`);

	/** FIXME : à supprimer qd utilisation de inset-inline-start/inset-inline-end */
	reg.overlaySkin("wed-diff-txtobj", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  :host {
			right: unset;
			left: 0;
	}
	`);

	/** FIXME : à supprimer qd utilisation de inset-inline-start/inset-inline-end */
	reg.overlaySkin("wed-annot-search", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  :host {
		  right: unset;
		  left: 0;
	  }
	`);

	reg.overlaySkin("wed-diffbar", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  c-button-actions {
		  background-position: right;
	  }
	`);


	reg.overlaySkin("box-input-enum", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  :host {
		  background-position: right;
	  }
	`);

	reg.overlaySkin("box-mark-rep-ctn", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  :host {
		  background: linear-gradient(to left, var(--edit-drop-bgcolor), var(--edit-drop-bgcolor), transparent);
	  }

	  :host(:hover),
	  :host(:focus) {
		  background: linear-gradient(to left, var(--edit-drop-bgcolor), var(--edit-drop-bgcolor), transparent);
	  }
	`);

	reg.overlaySkin("txt-tbl-editor", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  .insRow {
		  margin-left: 0;
	  }

	  .delRow {
		  margin-left: -1.2em;
	  }
	`);
}


